/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Home_TitleInputs */

const cs_portal_home_title = /** @type {(inputs: Portal_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zprávy`)
};

const en_portal_home_title = /** @type {(inputs: Portal_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Portal_Home_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_home_title = /** @type {((inputs?: Portal_Home_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Home_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_home_title(inputs)
	return cs_portal_home_title(inputs)
});